import { render, staticRenderFns } from "./AdminDeadlines.vue?vue&type=template&id=6a30c1a5&scoped=true&"
import script from "./AdminDeadlines.vue?vue&type=script&lang=js&"
export * from "./AdminDeadlines.vue?vue&type=script&lang=js&"
import style0 from "./AdminDeadlines.vue?vue&type=style&index=0&id=6a30c1a5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a30c1a5",
  null
  
)

component.options.__file = "AdminDeadlines.vue"
export default component.exports